import { apiClient } from '~/api/client'

// 알림·발송(SMTP) 설정 API + 도메인 타입. NotificationSettingsPage가 쓴다.
// DB에 저장된 값이 환경변수보다 우선한다. 비밀번호는 write-only(응답에 절대 내려오지 않음).

/** 해석된 SMTP 설정. `secretSet`=비밀번호 설정 여부, `source`=출처(db 저장값 / env 환경변수). */
export interface EmailSettings {
    host: string | null
    port: number
    username: string | null
    fromAddress: string | null
    useTls: boolean
    enabled: boolean
    /** 비밀번호가 설정돼 있는지. 비밀번호 값/암호문은 내려오지 않음. */
    secretSet: boolean
    /** 설정 출처: 'db'=DB 저장값(우선) / 'env'=환경변수 폴백. */
    source: 'db' | 'env'
}

/** SMTP 설정 저장 본문. password를 비우면(null) 기존 비밀번호를 유지한다. */
export interface UpdateEmailSettingsInput {
    host: string
    port: number
    username: string
    fromAddress: string
    useTls: boolean
    enabled: boolean
    /** 실제 비밀번호(write-only). 비우면(null) 기존 유지, 값이 있으면 서버가 암호화 저장. */
    password: string | null
}

/** POST /settings/email/test 응답. ok=발송 성공, detail=결과 사유(비밀번호 미포함). */
export interface TestEmailResult {
    ok: boolean
    detail: string
}

export const getEmailSettings = () =>
    apiClient.get<EmailSettings>('/settings/email')

export const updateEmailSettings = (body: UpdateEmailSettingsInput) =>
    apiClient.put<EmailSettings>('/settings/email', body)

/** POST /settings/email/test — 저장된(또는 env) 설정으로 테스트 메일을 보낸다. */
export const sendTestEmail = (recipient: string) =>
    apiClient.post<TestEmailResult>('/settings/email/test', { recipient })
